/* src/app/modules/print-cards/components/cut-lines/print-card-internal-grid-cut-lines/print-card-internal-grid-cut-lines.component.scss */
:host {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
}
/*# sourceMappingURL=print-card-internal-grid-cut-lines.component.css.map */
